import { formatDate } from '@edge/spark/utils'
import type { SearchVehicle } from '../types'

export const checkedInAt = ({ checkedInAt: _checkedInAt }: SearchVehicle): string =>
    formatDate(_checkedInAt, { type: 'shortNumeric' }) || '—'
